import nestedy from '@/modules/nestedy';

const phoner = (options = {}) => {
  const content = options.content || '[data-nestedy-content]';
  const model = options.model || '[data-nestedy-item]';
  const removeButton = options.removeButton || '[data-nestedy-remove]';
  const wrapper = document.querySelector(options.wrapper || '[data-phones]');

  if (!wrapper) return;

  nestedy(wrapper, {
    change: (count) => document.querySelector('[data-phones-none]').classList.toggle('hidden', count > 0),
    content,
    model,
    removeButton,
    template: '#phone-template',
  }).init();
};

export default phoner;
